/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-30 11:23:54
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-14 13:52:08
 * @FilePath: /src/app/payment/components/Points/components/PointDialog.tsx
 * @Description: 积分规则对话框
 */
'use client';

import { fetchPointsMallRules } from '@/api/account';
import Button from '@/components/Button';
import Dialog from '@/components/Dialog';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import logger from '@/utils/client-logger';
import { EPlatform } from '@/utils/enums/platform-enum';
import { useContext, useEffect, useState } from 'react';

interface PointDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function PointDialog({ open, onClose }: PointDialogProps) {
  const [paymentContent, setPaymentContent] = useState('');
  const { deviceType } = useContext(ResponsiveContext);
  const isWeb = deviceType === EPlatform.WEB;
  useEffect(() => {
    if (open) {
      getPointRule();
    }
  }, [open]);

  const getPointRule = async () => {
    try {
      const response = await fetchPointsMallRules();
      const content = response?.data?.point_rule_description?.paymentContent || '';
      setPaymentContent(content);
    } catch (error) {
      logger.log(error);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      footer={null}
      sx={{
        '& .MuiDialog-paper': {
          width: isWeb ? '680px' : '85.3vw',
          margin: '0 auto',
          borderRadius: isWeb ? '12px' : '32px',
        },
        '& .MuiDialogTitle-root': {
          paddingBottom: 0,
        },
      }}
    >
      <div>
        <div
          dangerouslySetInnerHTML={{ __html: paymentContent }}
          className="point-dialog-content"
          style={{
            fontSize: '14px',
          }}
        />

        <div className={`text-center ${isWeb ? 'mt-[48px]' : 'mt-[32px]'}`}>
          <Button
            variant="contained"
            color="primary"
            onClick={onClose}
            sx={{
              height: '48px',
              borderRadius: isWeb ? '4px' : '24px',
              fontSize: '16px',
              fontFamily: 'var(--font-bricolage-bold)',
            }}
            className="w-full md:w-[420px]"
          >
            OK
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
